module.exports = __webpack_public_path__ + "components/country-flag/static/no-803a185e00f0bf9379ae3f6e4e0846c8.svg";